import { takeLatest, call, put } from 'redux-saga/effects';

import api from '../api';
import {
    Task,
    listTasksRequest,
    listTasksSuccess,
    listTasksFailure,
    updateTasksRequest,
    updateTasksSuccess,
    updateTasksFailure,
} from './actions';

// API calls
const listTaskApi = async (filters: string, task_fields: string, excludes: string, vehicle_id?: number): Promise<Task[]> => {
    let params = new URLSearchParams({
        filters: filters || '',
        excludes: excludes || '',
        task_fields: task_fields
    }).toString();

    if (vehicle_id) {
        params += (params ? '&' : '') + 'vehicle_id=' + vehicle_id.toString();
    }

    const response = await api.get('/main/api/tasks/list/?' + params);

    return response.data as Task[];
};

const updateTasksApi = async (tasks: Task[], update_fields: string[], task_fields?: string, vehicle_id?: number): Promise<Task[]> => {
    let params = "";

    if (task_fields) {
        params = "?"+ new URLSearchParams({
            task_fields: task_fields
        }).toString();
    }

    if (vehicle_id) {
        params += params ? '&' : '?' + 'vehicle_id=' + vehicle_id.toString();
    }

    const tasks_data: Task[] = update_fields.length > 0 ? Object.values(tasks).map((el) =>
        Object.fromEntries(Object.entries(el).filter(([key]) => update_fields.includes(key)))
    ) as Task[] : tasks;

    const removed_tasks: number[] = tasks.filter((el) => el.is_removed).map((el) => el.id as number);

    const response = await api.post('/main/api/tasks/post/' + params, {
        tasks: tasks_data,
        removed_tasks: removed_tasks
    });

    return response.data as Task[];
};

// Sagas
function* handleListTask(action: ReturnType<typeof listTasksRequest>) {
    try {
        const data: Task[] = yield call(
            listTaskApi,
            action.payload.filters,
            action.payload.task_fields,
            action.payload.excludes,
            action.payload.vehicle_id
        );
        yield put(listTasksSuccess(data));
    } catch (error: any) {
        yield put(listTasksFailure(error.response?.data as string || 'Failed to list tasks'));
    }
}

function* handleUpdateTasks(action: ReturnType<typeof updateTasksRequest>) {
    try {
        const data: Task[] = yield call(
            updateTasksApi,
            action.payload.tasks,
            action.payload.update_fields,
            action.payload.task_fields,
            action.payload.vehicle_id
        );

        if (action.payload.cb) {
            action.payload.cb(data);
        }

        const removed_tasks: number[] = action.payload.tasks.filter((el) => el.is_removed).map((el) => el.id as number);

        yield put(updateTasksSuccess({tasks: data, removed_tasks: removed_tasks}));
    } catch (error: any) {
        yield put(updateTasksFailure(error.response?.data || 'Failed to update tasks'));
    }
}

// Watcher sagas
export function* watchTasksSaga() {
    yield takeLatest(listTasksRequest.type, handleListTask); // Listen for list tasks request
    yield takeLatest(updateTasksRequest.type, handleUpdateTasks);
}
